import Fuse from "fuse.js";

const searchSort = (sites, query, sortKey) => {
  const fuseOptions = {
    keys: ["name", "domain"],
    threshold: 0.25,
    isCaseSensitive: false,
  };

  const fuse = new Fuse(sites, fuseOptions);
  const searchResults = query ? fuse.search(query).map((result) => result.item) : sites;

  return searchResults.sort((a, b) => {
    switch (sortKey) {
      case "last_access":
        return new Date(b.last_access) - new Date(a.last_access);
      case "name":
        return a.name.localeCompare(b.name);
      case "create_date":
        return new Date(b.create_date) - new Date(a.create_date);
      default:
        return new Date(b.last_access) - new Date(a.last_access);
    }
  });
};

export default {
  searchSort,
};
